import '../../../../images/integrations/circle.png';
import '../../../../images/integrations/teachable.png';
import '../../../../images/integrations/webflow.png';
import '../../../../images/integrations/weebly.png';
import '../../../../images/integrations/shopify.png';
import '../../../../images/integrations/wordpress.png';
import '../../../../images/integrations/squarespace.png';
import '../../../../images/integrations/wix.png';

export default {
    integrationsArray: [
        {
            type: 'wordpress',
            name: 'Wordpress',
            image: '/images/integrations/wordpress.png',
            link: 'http://support.fusebox.fm/article/423-fusebox-on-wordpress',
            helpScoutId: '5fbbbe13cff47e0017d34766',
        },
        {
            type: 'webflow',
            name: 'Webflow',
            image: '/images/integrations/webflow.png',
            link: 'http://support.fusebox.fm/article/434-fusebox-on-webflow',
            helpScoutId: '5fd4ef83c868cb6df3a810af',
        },
        {
            type: 'squarespace',
            name: 'Squarespace',
            image: '/images/integrations/squarespace.png',
            link: 'http://support.fusebox.fm/article/420-fusebox-on-squarespace',
            helpScoutId: '5fb7eb4b46e0fb0017fce1f1',
        },
        {
            type: 'weebly',
            name: 'Weebly',
            image: '/images/integrations/weebly.png',
            link: 'http://support.fusebox.fm/article/450-fusebox-on-weebly',
            helpScoutId: '5fe205996451e825e3b8d2d9',
        },
        {
            type: 'wix',
            name: 'Wix',
            image: '/images/integrations/wix.png',
            link: 'http://support.fusebox.fm/article/414-fusebox-on-wix',
            helpScoutId: '5fb2f7a04cedfd001610d5dc',
        },
        {
            type: 'circle',
            name: 'Circle',
            image: '/images/integrations/circle.png',
            link: 'http://support.fusebox.fm/article/431-fusebox-on-circle',
            helpScoutId: '5fc53f990f48dc44854dc118',
        },
        {
            type: 'teachable',
            name: 'Teachable',
            image: '/images/integrations/teachable.png',
            link: 'http://support.fusebox.fm/article/422-fusebox-on-teachable',
            helpScoutId: '5fb7eb85cff47e00160bc1a3',
        },
        {
            type: 'shopify',
            name: 'Shopify',
            image: '/images/integrations/shopify.png',
            link: 'http://support.fusebox.fm/article/421-fusebox-on-shopify',
            helpScoutId: '5fb7eb6fcff47e0017d33f7b',
        },
    ],
};
